export const cleanText = (text) => {
  let result = text.replace(/<[^>]+>/g, "");
  result = result.replace(/&nbsp;/g, "");
  result = result.replaceAll("<p>", "").replaceAll("</p>", `, `);
  return result;
};

export const stripHtmlTags = (html) => {
  if (html) {
    return html.replace(/<(?!\/?p(?=>|\s.*>))\/?.*?>/g, "");
  } else {
    return "";
  }
};

export const stripH2Tag = (html) => {
  if (html) {
    return html.replace(/<h\d.*?>(.*?)<\/h\d>/gi, "$1");
  } else {
    return "";
  }
};

export const stripAllHtmlTags = (html) => {
  let result = html.replace(/<\/?[^>]+(>|$)/g, " ");
  result = result.replace(/&nbsp;/g, " ");
  return result;
};
